export default {
  preferences: {
    title: "Préférences",
    promo: {
      blurb: "Jeux avancés.\nAnalyses plus profondes.",
    },
    sections: {
      account: "Compte",
      display: "Affichage",
      support: "Assistance",
      about: "À propos",
    },
    items: {
      profile: "Profil",
      location: "Emplacement",
      manageSubscription: "Gérer l'abonnement",
      glossary: "Glossaire",
      contactSupport: "Contacter l'assistance",
      logOut: "Déconnexion",
      deleteAccount: "Supprimer le compte",
    },
    profile: {
      title: "Profil",
      alerts: {
        passwordMessage: "Pour changer votre mot de passe, visitez linemate.io",
        usernameInvalid: "Votre nom d'utilisateur doit contenir au moins 6 caractères. Il ne doit contenir que des lettres et des chiffres.",
        usernameTaken: "Ce nom d'utilisateur est déjà utilisé",
      },
      saved: "Profil enregistré",
    },
    display: {
      preferences: {
        theme: "Thème",
        odds: "Cotes",
        language: "Langue",
      },
      options: {
        theme: {
          "Match System": "Comme le système",
          Light: "Clair",
          Dark: "Sombre",
        },
        odds: {
          american: "Américaines",
          decimal: "Décimales",
        },
      },
    },
    language: {
      loading: "Mise à jour de la langue...",
    },
    about: {
      terms: "Conditions",
      privacy: "Confidentialité",
      responsibleGambling: "Jeu responsable",
      openSourceLibraries: "Bibliothèques open source",
      acknowledgments: "Remerciements",
    },
    subscription: {
      alertTitle: "Abonnement",
      webMessage: "Pour gérer votre abonnement, veuillez visiter la section profil sur linemate.io",
      googlePlayMessage: "Pour gérer votre abonnement, veuillez visiter la section Abonnements du compte Google Play Store associé à cet achat",
      appleMessage: "Pour gérer votre abonnement, veuillez visiter la section Abonnements du compte Apple associé à cet achat",
      manageTitle: "Gérer l'abonnement",
      currentPlan: "Forfait actuel",
      changePlan: "Changer de forfait",
      cancelPlan: "Annuler l'abonnement",
      cancelTitle: "Annuler l'abonnement",
      cancelHeading: "Pourquoi annulez-vous?",
      cancelSubtitle: "Vos commentaires nous aideront à améliorer notre produit.",
      missingTitle: "Qu'est-ce qui manque?",
      missingSubtitle: "Quelles fonctionnalités ou quels outils rendraient Linemate plus utile pour vous?",
      improveTitle: "Dites-nous comment nous améliorer",
      improveSubtitle: "Vos commentaires nous aident à nous améliorer.",
      trialActive: "Votre essai Linemate+ est toujours actif.",
      alreadyActive: "Vous avez déjà accès à Linemate+",
      exclusiveOfferFallbackTitle: "Offre exclusive",
      exclusiveOfferFallbackSubtitle: "Conservez votre accès avec une offre limitée avant d'annuler.",
      claimOneTimeOffer: "Réclamer l'offre unique",
      offerApplyFailure: "Nous n'avons pas pu appliquer cette offre pour le moment. Veuillez réessayer plus tard.",
      continueToCancel: "Continuer l'annulation",
      losingAccessTitle: "Vous allez perdre l'accès à nos plus récentes fonctionnalités avancées",
      losingAccessSubtitle: "Voici ce que vous perdrez lorsque votre forfait prendra fin.",
      keepSubscription: "Conserver l'abonnement",
      feedbackPlaceholder: "Entrez votre réponse...",
    },
    providers: {
      locationTitle: "Autorisez Linemate à accéder à votre emplacement pour définir vos cotes préférées",
      locationSubtitle: "Linemate utilise votre emplacement pour afficher les fournisseurs de votre région",
    },
    location: {
      title: "Emplacement",
      useCurrentLocation: "Utiliser l'emplacement actuel",
      enableLocationMessage: "Gagnez du temps et autorisez le partage de votre emplacement afin que nous puissions afficher les meilleurs marchés et offres.",
    },
    logout: {
      title: "Déconnexion",
      message: "Voulez-vous vraiment vous déconnecter?",
    },
    deleteAccount: {
      warningTitle: "Avertissement",
      warningMessage: "Vous avez actuellement un abonnement actif; vous devrez l'annuler avant de supprimer votre compte.",
      confirmTitle: "Supprimer le compte",
      confirmMessage: "Voulez-vous vraiment supprimer votre compte?",
      confirmAction: "Supprimer",
      successTitle: "Supprimer le compte",
      successMessage: "Votre compte a été supprimé avec succès.",
      errorTitle: "Erreur",
    },
    communication: {
      title: "Communication",
      email: "Courriel",
      emailDescription: "Courriels marketing, mises à jour de recherche, nouvelles du produit et annonces occasionnelles de la plateforme.",
      notificationSettings: "Paramètres de notification",
      notificationDescription: "Notifications marketing, rappels avant les moments clés des matchs et mises à jour sur les nouvelles fonctionnalités.",
    },
    feedback: {
      title: "Partager des commentaires",
      enjoymentPrompt: "Appréciez-vous votre expérience?",
      improvePrompt: "Dites-nous comment nous pouvons nous améliorer. Chaque commentaire compte.",
      actions: {
        yes: "Oui",
        no: "Non",
        contactUs: "Nous contacter",
        notNow: "Pas maintenant",
      },
      communication: {
        title: "Communication",
        email: "Courriel",
        emailDescription: "Courriels marketing, mises à jour de recherche, nouvelles du produit et annonces occasionnelles de la plateforme.",
        notificationSettings: "Paramètres de notification",
        notificationDescription: "Notifications marketing, rappels avant les fenêtres de matchs importantes et mises à jour sur les nouvelles fonctionnalités.",
      },
    },
  },
};
